export default __webpack_public_path__ + "static/media/logo-pinterest.84470903.svg";